// removed by extract-text-webpack-plugin
module.exports = {"page_buy":"app__css__app-pages-SelfHelp-examination-__index__page_buy","page_pay":"app__css__app-pages-SelfHelp-examination-__index__page_pay"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/SelfHelp/examination/index.css
// module id = 1570
// module chunks = 0